import scripts_gen_2 from '@devices/settings/device_settings/scripts_gen_2.js';
import virtual_components from '@devices/settings/device_settings/virtual_components.js';
import networks_camera from '@devices/settings/device_settings/networks_camera.js';
import app_setting_camera from '@devices/settings/device_settings/app_setting_camera.js';
import share from '@devices/settings/device_settings/share.js';
import bluetooth_gen_2 from '@devices/settings/device_settings/bluetooth_gen_2';
import schedule_gen_2 from '@devices/settings/device_settings/schedule_gen_2.js';
import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';

export default {
	name: 'ShellyCamera',
	friendly_name: 'Android Camera',
	family: 'camera',
	isPM: false,
	modes: {
		camera: {
			availableViews: ['basic'],
			channels: 1,
			notifications: ['offline', 'device_problem'],
			settings: [
				schedule_gen_2,
				webhooks_gen_2,
				scripts_gen_2,
				virtual_components,
				networks_camera,
				bluetooth_gen_2,
				app_setting_camera,
				share,
				{
					title: 'settings',
					components: [
						{
							title: 'device_information',
							component: 'device_information',
						},
					],
				},
			],
		},
	},
};
